import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=145d11f6&scoped=true&"
import script from "./InviteModal.js?vue&type=script&lang=js&"
export * from "./InviteModal.js?vue&type=script&lang=js&"
import style0 from "../AuthModal/AuthModal.scss?vue&type=style&index=0&id=145d11f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d11f6",
  null
  
)

export default component.exports